import FetchData, { IAPIResponse } from '../../ServerCall/FetchData';
import { setFiltersOfGroup } from '../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { callQueryAPI } from '../../../redux/ChartPoperties/ChartControlsActions';
import { callQueryAPIDashboard } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { IChartFIlter } from '../interfaces';

export async function getAllFilterOptions({
  group,
  dsDetails,
  token,
  dispatch,
  chartGroup,
  dashBoardFilterGroup,
  setLoading,
  fromButtonAction = false,
}: any) {
  const promises: {
    res: Promise<IAPIResponse<Record<string, any>>>;
    filterUid: string;
  }[] = [];
  const nonPickListFilters: {
    filterId: string;
    filterType: 'Search Condition' | 'Relative Filter';
  }[] = [];
  const filters = group.filters;
  group.filters.forEach((filter: IChartFIlter, idx: number) => {
    if (filter.fieldtypeoption === 'Pick List') {
      const payload = {
        tableId: filter.tableId,
        fieldName: filter.displayname,
        dataType: filter.dataType,
        filterOption: 'allValues',
        ...(filter.dataType === 'timestamp' || filter.dataType === 'date'
          ? { timeGrain: filter.prefix ?? 'year' }
          : {}),
      };
      const url = `filter-options?datasetid=${dsDetails.id}&workspaceId=${
        dsDetails.workSpaceId
      }&${dsDetails.isFlatFileData ? '' : `dbconnectionid=${dsDetails.connectionId}`}`;
      promises.push({
        res: FetchData<Record<string, any>>({
          method: 'POST',
          url: url,
          requestType: 'withData',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          data: payload,
        }),
        filterUid: filter.uId,
      });
    } else if (filter.fieldtypeoption === 'Relative Filter') {
      nonPickListFilters.push({ filterId: filter.uId, filterType: 'Relative Filter' });
    } else if (filter.fieldtypeoption === 'Search Condition') {
      nonPickListFilters.push({ filterId: filter.uId, filterType: 'Search Condition' });
    }
  });

  if (promises.length > 0) {
    try {
      setLoading(true);
      const res = await Promise.all(
        promises.map((item) => item.res),
      );
      res.forEach(
      (response, idx: number) => {
        if (response.status && response.data) {
          const avalableOptions = response.data[Object.keys(response.data)[0]];
          const result = avalableOptions.map((value: any) => {
            return value !== null
              ? typeof value === 'boolean'
                ? value
                  ? 'True'
                  : 'False' // Convert boolean to string
                : value
              : '(Blank)';
          });
          const options = ['(All)', ...result];

          const filterIndex = group.filters.findIndex(
            (filter: any) => filter.uId === promises[idx].filterUid,
          );
          filters[filterIndex].userSelection = [];
          filters[filterIndex].rawselectmembers = options;
          filters[filterIndex].rawselectmembersOriginal = options;
          filters[filterIndex].callAPI = true;
        }
      });
    } catch (e) {
      setLoading(false);
      console.log(e);
    } finally {
      setLoading(false);
    }
  }
  if (nonPickListFilters.length > 0) {
    nonPickListFilters.forEach((filter) => {
      const filterIndex = group.filters.findIndex((f: any) => f.uId === filter.filterId);
      if (filter.filterType === 'Search Condition') {
        filters[filterIndex].exprInput = '';
        filters[filterIndex].greaterThanOrEqualTo = undefined;
        filters[filterIndex].lessThanOrEqualTo = undefined;
        filters[filterIndex].callAPI = true;
      } else if (filter.filterType === 'Relative Filter') {
        filters[filterIndex].exprInputFromValueType = undefined;
        filters[filterIndex].exprInputToValueType = undefined;
        filters[filterIndex].exprInputSpecificDate = '';
        if (
          filters[filterIndex].expTypeFromRelativeDate !== 'current' ||
          filters[filterIndex].expTypeToRelativeDate !== 'current'
        ) {
          filters[filterIndex].fromDate = null;
          filters[filterIndex].toDate = null;
        }

        filters[filterIndex].callAPI = true;
      }
    });
  }
  dispatch(setFiltersOfGroup(group.id, filters));
  if (!fromButtonAction) {
    dispatch(callQueryAPIDashboard(true));
    Object.entries(chartGroup.tabTile).forEach(([tabTileId, arr]: any) => {
      if (dashBoardFilterGroup.filterGroupTabTiles[group.id]?.includes(tabTileId)) {
        dispatch(callQueryAPI(tabTileId, true));
      }
      if (arr.includes(group.id)) {
        dispatch(callQueryAPI(tabTileId, true));
      }
    });
  }
}
